/* eslint-disable */
import {
  Button,
  Select,
  DatePicker,
  Flex,
  message,
  Image,
  Space,
  Form,
  Input,
  Modal,
  Steps,
  Radio,
  Spin,
} from "antd";
import React, {
  useEffect,
  useState,
  useRef,
} from "react";
import "@/common.css";
import {

  UploadOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import { Typography } from "antd";
import http from "@/utils/http";
import { Card, Col, Row } from "antd";
import "../UserCompon.css";
import moment from "moment";
import { useLocation } from "react-router-dom";
import UplaodFile from "@/components/UplaodFile";
export default function NewOrder() {
  // 默认选中的值

  const childRef = useRef();
  const location = useLocation();
  const state = location.state || {};
  const [user, setUser] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isAddModal, setIsisAddModal] = useState(false);

  const [uploadImg, setUploadImg] = useState([]); // 表格数据
  const [fileList, setFileList] = useState([]); // 表格数据

  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({}); // 每列的输入值
  const [selectionType] = useState("checkbox");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = React.useState(null);
  const [form, form2, form3, form4] = Form.useForm();
  const [select1Value, setSelect1Value] = useState(null);
  const [selectPropData, setSelectPropData] = useState(null);
  const [unitValue, setUnitValue] = useState(null);
  const [BtnLoading, setBtnLoading] = useState(false);
  const [modalupload, setmodalupload] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tableoading, setTableoading] = useState(false);
  const [propId, setPropId] = useState([]);
  const [unitId, setUnitId] = useState([]);
  const [modelEdit, setdModelEdit] = useState(null);
  const [nowMainten, setNowMainten] = useState(null);
  const [stepShow, setstepShow] = useState(0);
  const [propValue, setPropValue] = useState(0); //propUnit
  const [remark, setRemark] = useState("");
  const [remarkLength, setRemarkLength] = useState(0);
  const [remainingChars, setRemainingChars] = useState(250);
  const [setpDataOne, setSetpDataOne] = useState({
    //step1上传资料
    maintenanceId: null,
    processId: null,
    files: [],
  });
  const [tableHead, setTableHead] = useState({
    id: null,
  });
  //初始化数据
  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 16,
    },
  };

  const [descrItems, setdDescrItems] = useState([
    {
      key: "1",
      label: "Remark",
      children: "这是一条备注信息",
    },
  ]);

  //表单规则
  const validateMessages = {
    required: "${label} is required!",
    types: {
      email: "${label} is not a valid email!",
      number: "${label} is not a valid number!",
    },
    number: {
      range: "${label} must be between ${min} and ${max}",
    },
  };
  //选择propId
  // const onPropFocus = () =>{
  //   console.log('获取焦点===========>');
  //   propIdFun('');
  // };

  const onPropTypeChange = (value, options) => {
    console.log("点击事件");
    setSelect1Value(value);
    unitIdFun(value, "", "");
    setSelectPropData(options);
  };
  const onTypeSearch = (value, option) => {
    propIdFun(value);
  };
  //选择unitId
  const unitChange = (value, option) => {
    setUnitValue(value);
    const propData = option;
    setPropValue(propData);
  };
  const unitSearch = (value) => {
    console.log("search:", value);
    unitIdFun(select1Value, value, "");
  };

  //获取propIdunit
  const unitIdFun = async (propId, content, showId) => {
    try {
      const response = await http.get(
        `${api.unitSearch}?content=${content}&propId=${propId}`
      );
      console.log(response);
      if (response && response.data) {
        const formattedData = response.data.map((item) => ({
          value: item.unitId,
          label: item.unitName,
          city: item.city,
          add: item.street,
          prop: item.prop,
          unit: item.unit,
        }));
        const newformattedData = [
          { value: "CommonArea", label: "Common Area" },
          ...formattedData,
        ];
        setUnitId(newformattedData);
        if (showId) {
          const nowIndex = formattedData.findIndex(
            (item) => item.value === showId
          );
          if (index !== -1) setUnitValue(formattedData[nowIndex]?.value); //找到对象
        }
      }
    } catch (err) {
      setError(err);
    } finally {
      setBtnLoading(false); // 设置加载状态
    }
  };
  //获取propId
  const propIdFun = async (content, showId) => {
    console.log("获取prop");
    try {
      // const response = await http.get(`${api.propSearch}?content=${content}`);
         const response = await http.get(`${api.getPropSearch}?content=${content}`);
      if (response && response.data) {
        console.log("获取到prpid数据");
        setLoading(false);
        const formattedData = response.data.map((item) => ({
          value: item.propId,
          label: item.propName,
          city: item.city,
          add: item.street,
          prop: item.prop,
        }));
        setPropId(formattedData);
        if (showId) {
          const nowIndex = formattedData.findIndex(
            (item) => item.value === showId
          );
          console.log(formattedData[nowIndex]?.value);
          if (index !== -1) setSelect1Value(formattedData[nowIndex]?.value); //找到对象
        }
      }
    } catch (err) {
      setError(err); // 捕获错误
    } finally {
      //setBtnLoading(false)  // 设置加载状态
    }
  };

  const remarkChange = (e) => {
    console.log(e.target.value);
    const value = e.target.value;
    if (value.length <= 250) {
      setRemark(value);
      setRemarkLength(value.length);
      setRemainingChars(250 - value.length);
    }
  };

  // 示例:在你的 `addUpload` 方法中调用
  const addUoload = async (data) => {
    console.log(data);
    const uploadedFiles = await uploadFiles(data);
    console.log("上传成功的文件信息:", uploadedFiles);
    form.setFieldsValue({ files: uploadedFiles }); // 将格式化后的文件信息设置到表单中
  };

  //
  const addSubmit = () => {
    //   setOpen(false);
  };

  //表单form1提 交
  const onFinish = (values) => {
    if (values.remark.length < 5) {
      message.warning("Remark requires at least 5 words to be entered."); //remark至少要输入5个字
    } else {
      const updateValues = {
        ...values,
        createBy: localStorage.getItem("accountId"),
        createByType: "1",
      };
      form.setFieldsValue(updateValues); //添加表单
      addFun(updateValues);
    }
  };

  //添加新工单
  const addFun = async (data) => {
    setBtnLoading(true);
    const accountIdNew = localStorage.getItem("accountId");
    const propUnitValue = propValue.prop + "-" + propValue.unit;

    if (data.unitId === "CommonArea") {
      const stepOneData = {
        propId: data.propId,
        remark: data.remark,
        unitId: -1,
        filePaths: fileList, //data.files
      };

      try {
        const response = await http.post(
          `${api.addMaintenanceNon}`,
          stepOneData
        );
        if (response.code == 1) {
          message.success("Successfully Added.");
          form.resetFields();
          setFileList([]);
          setRemark(""); 
          setRemainingChars(250);
          navigate(0);
        }
      } catch (err) {
        setError(err);
      } finally {
        setBtnLoading(false);
      }
    } else {
      const stepOneData = {
        propId: data.propId,
        remark: data.remark,
        unitId: data.unitId,
        filePaths: fileList, //data.files
      };
      console.log("params", stepOneData);
      try {
        const response = await http.post(
          `${api.addMaintenanceNon}`,
          stepOneData
        );
        if (response.code == 1) {
          message.success("Successfully Added.");
          form.resetFields();
          setFileList([]);
          setRemark(""); 
          setRemainingChars(250); 
          navigate(0);
        }
      } catch (err) {
        setError(err); // 捕获错误
      } finally {
        setBtnLoading(false); // 设置加载状态
      }
    }
  };

  const { confirm } = Modal;

  //步骤
  const stepsItems = [
    {
      title: (
        <Flex justify="flex-start" align="flex-start">
          <Space size="small">
            <div>
              <strong>Request Content</strong>
            </div>
          </Space>
        </Flex>
      ),
      hidden: false,
      description:
        stepShow === 0 ? (
          <Card loading={tableoading} style={{ minWidth: 300 }}>
            <div>
              <Form
                {...layout}
                onFinish={onFinish}
                form={form}
                labelCol={{ span: 2 }}
                initialValues={modelEdit}
                validateMessages={validateMessages}
                className="model_top"
              >
                <Form.Item
                  name="propId"
                  label="Property"
                  rules={[{ required: true }]}
                  className="mt30"
                >
                  <Select
                    showSearch
                    placeholder="Select a prop"
                    onChange={onPropTypeChange}
                    onSearch={onTypeSearch}
                    optionFilterProp="label"
                    value={select1Value}
                    filterOption={false}
                    options={propId}
                  />
                </Form.Item>
                <Form.Item
                  name="unitId"
                  label="Unit"
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    placeholder="Select a unitId"
                    onChange={unitChange}
                    onSearch={unitSearch}
                    optionFilterProp="label"
                    value={unitValue}
                    filterOption={false}
                    options={unitId}
                  />
                </Form.Item>

                <Form.Item
                  name="remark"
                  label="Remark"
                  rules={[{ required: true }]}
                >
                  <div className="textarea-wrapper">
                    <Input.TextArea
                      value={remark}
                      onChange={remarkChange}
                      placeholder="Input at least 5 words (max 250 characters)"
                      maxLength={250}
                    />
                    <div className="character-count">
                      {remainingChars} characters remaining
                    </div>
                  </div>
                </Form.Item>
                <Form.Item name="files" label="Files">
                  <UplaodFile
                    ref={childRef}
                    uploadImg={uploadImg}
                    sendDataToParent={addUoload}
                  />
                </Form.Item>
                <Form.Item className="btnCenter">
                  <Space align="center" size="large">
                    <Button
                      type="primary"
                      htmlType="submit"
                      onClick={addSubmit}
                      loading={BtnLoading}
                      size="large"
                    >
                      Submit
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </div>
          </Card>
        ) : (
          <div></div>
        ),
    },
  ];
  const setProcess = async () => {
    setNowMainten(state);

    vendorFun("");
    setpFun(state.id);
    setdDescrItems((prevItems) => {
      // 复制原数组并更新指定元素
      const updatedItems = prevItems.map((item, index) => {
        if (index === 0) {
          // 定位到要更新的元素（索引为2）
          return {
            ...item,
            key: `key-${Date.now()}`, // 更新 key
            children: state.remark ? state.remark : "暂无", // 更新值
          };
        }
        return item; // 其他元素保持不变
      });
      return updatedItems; // 返回更新后的数组
    });

    setIsModalOpen(true);
  };

  //上传文件列表
  const handleUploadData = async (data) => {
    console.log("上传列表");
    console.log(data);
    const files = await uploadFiles(data);
    console.log(typeof files);
    console.log("上传成功的文件信息:", files);
    // const files = []
    // data.forEach(item => {
    //   files.push(item.originFileObj)
    // });
    const DataOne = { ...setpDataOne, files: files };
    setSetpDataOne(DataOne);
  };

  //添加时上传
  async function uploadFiles(data) {
    setIsisAddModal(true);

    console.log(
      "====================存储上传成功后的文件信息=========================="
    );
    console.log(data);
    const files = []; // 存储上传成功后的文件信息
    for (const item of data) {
      const formData = new FormData();
      console.log(item.originFileObj);
      formData.append("files", item.originFileObj); // 将文件添加到 FormData 中
      console.log(formData);
      // 打印 FormData 的内容，确保它有数据
      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value.name}`);
      }
      console.log(data);
      try {
        // 使用 axios 调用后端接口上传文件
        // const response = await http.post(`${api.UploadFile}`, formData,);
        const response = await http.post(`${api.UploadFile}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        console.log(response);
        if (response.code === "1") {
          console.log("=======8888===========");
          const result = response.data;
          console.log(result);
          files.push(result[0]);
          console.log(files);
          setFileList(files);
          setIsisAddModal(false);
        }
      } catch (error) {
        console.error("上传出错:", error);
      }
    }
    return files;
  }
  const actions = [
    <Button
      color="primary"
      variant="outlined"
      onClick={() => setmodalupload(true)}
    >
      <UploadOutlined />
      upload Image
    </Button>,
  ];

  // 使用 useEffect 在页面加载时执行方法
  useEffect(() => {
    setTimeout(() => {
      propIdFun("");
    }, 1000); // 延迟2秒
    if (state.id > 1) {
      setProcess();
    }
    // unitIdFun('');
  }, []); // 依赖数组为空，确保只在组件首次加载时执行

  return (
    <div>
      <div className="orderMain">
        <div className="stepMain">
          {isModalVisible ? (
            // 加载状态显示 Spin
            <div style={{ textAlign: "center", padding: "20px" }}>
              <Spin size="large" />
              <p style={{ marginTop: "10px" }}>Loading...</p>
            </div>
          ) : (
            // 数据加载完成后显示内容
            <Steps
              direction="vertical"
              current={stepShow}
              labelPlacement="vertical"
              items={stepsItems.filter((step) => !step.hidden)}
            />
          )}
        </div>
      </div>
    </div>
  );
}
